import styled from 'styled-components'
import { Form } from 'components/forms'

export const StyledForm = styled(Form)`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 15px;
`